function Share() {
  return <div className="text-4xl flex flex-col h-full justify-center items-center">Coming Soon</div>
}

export default Share
